import { CSSProperties } from 'react';

export const actualMobileBookingCardHeight = 370;

export const actualMobileBookingCardStyle: CSSProperties = {
  height: `${actualMobileBookingCardHeight}px`,
};

export const historicalMobileBookingCardHeight = 300;

export const historicalMobileBookingCardStyle: CSSProperties = {
  height: `${historicalMobileBookingCardHeight}px`,
};

export const actualDeskMobileBookingCardHeight = 300;

export const actualDeskMobileBookingCardStyle: CSSProperties = {
  height: `${actualDeskMobileBookingCardHeight}px`,
};

export const historicalDeskMobileBookingCardHeight = 230;

export const historicalDeskMobileBookingCardStyle: CSSProperties = {
  height: `${historicalDeskMobileBookingCardHeight}px`,
};
